import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-sms',
  name: 'Access SMS',
  category: 'access-integrations',
  description: 'Send SMS messages using the Access internal SMS service (Twilio). No credential setup required - uses system-managed account.',
  icon: 'MessageSquare',
  color: 'purple',
  version: '1.0.0',

  defaults: {
    name: 'Access SMS',
    color: '#7c3aed'
  },

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['access', 'sms', 'text', 'message', 'twilio', 'internal'],
};

export default definition;
